import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PoolFileData, QueryPollFileDataArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryPollFileDataArgs;
type TData = Array<PoolFileData>;

const MOCK: TVariables = {
  uids: [],
  fileType: undefined
};

export const usePollFileData = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query pollFileData($uids: [ID!]!, $fileType: FileTypeEnum) {
      pollFileData(uids: $uids, fileType: $fileType) {
        processing
        progress
        hasErrors
        fileData
        errorMessage
        fileId
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['pollFileData', variables.uids],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
